import type { Enums } from "../types";

/**
 * Returns the UI color for the given attendance state.
 *
 * @param state - The attendance state enum value.
 * @returns The color token corresponding to the state.
 */
export function getAttendanceStateColor(state: Enums<"attendanceState">): Enums<"color"> {
	switch (state) {
		case "pending":
			return "gray";
		case "approved":
			return "emerald";
		case "rejected":
			return "red";
	}
}
